export default __webpack_public_path__ + "static/media/thumbnail.4e40eb56.png";